export { resolveAppData } from './resolve-app-data';
export { getProductContext } from './get-product-context';
export type { ProductContext } from './get-product-context';
export type {
    AppPageViewModel,
    AppRouteKind,
    AppSeoViewModel,
    AppShellViewModel,
    ResolvedAppData
} from './app-data.types';
